export default __webpack_public_path__ + "static/media/logo-github.469cc31b.svg";